import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const MessageContent = styled.div`
  padding: 0 20px;
`;
